if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.timerMode = this.dataset.timerMode || 'end_date';
      this.dailyResetTime = this.dataset.dailyReset || '03:00';

      if (this.timerMode === 'daily') {
        this.endDate = this.getDailyTarget();
      } else {
        this.endDate = new Date(this.dataset.endDate).getTime();
      }

      if (!Number(this.endDate)) return;

      window.initLazyScript(this, this.init.bind(this));
    }

    getDailyTarget() {
      var parts = this.dailyResetTime.split(':');
      var t = new Date();
      t.setHours(parseInt(parts[0] || 0), parseInt(parts[1] || 0), 0, 0);
      if (t <= new Date()) t.setDate(t.getDate() + 1);
      return t.getTime();
    }

    init() {
      this.daysEl = this.querySelector('.js-days');
      this.hoursEl = this.querySelector('.js-hours');
      this.minsEl = this.querySelector('.js-mins');
      this.secsEl = this.querySelector('.js-secs');

      this.second = 1000;
      this.minute = 60 * this.second;
      this.hour = 60 * this.minute;
      this.day = 24 * this.hour;

      this.timer();
      this.interval = setInterval(this.timer.bind(this), this.second);
    }

    timer() {
      const timeDiff = this.endDate - new Date();

      if (timeDiff < 0) {
        if (this.timerMode === 'daily') {
          this.endDate = this.getDailyTarget();
          return;
        }
        clearInterval(this.interval);
        return;
      }

      const days = Math.floor(timeDiff / this.day);
      const hours = Math.floor(timeDiff / this.hour);
      const mins = Math.floor(timeDiff / this.minute);
      const secs = Math.floor(timeDiff / this.second);

      this.daysEl.textContent = days;
      this.hoursEl.textContent = hours - days * 24;
      this.minsEl.textContent = mins - hours * 60;
      this.secsEl.textContent = secs - mins * 60;
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
